export const browserSupport = {
    isSupportedBrowser: true,
    requirements: {},
};
